import React from "react"

import {
  NewsletterContainer,
  NewsletterText,
  NewsletterHeading,
  NewsletterBody,
  NewsletterForm,
  NewsletterInput,
  NewsletterLabel,
} from "./NewsletterElement"

import { ButtonFormWhite } from "../../../Buttons"

const Newsletter = ({ heading, body }) => {
  return (
    <NewsletterContainer>
      <NewsletterText>
        <NewsletterHeading>{heading}</NewsletterHeading>
        <NewsletterBody>{body}</NewsletterBody>
      </NewsletterText>

      <NewsletterForm
        name="newsletter"
        method="POST"
        data-netlify="true"
        action="/newsletter-thank-you"
      >
        <input type="hidden" name="form-name" value="newsletter" />

        <NewsletterLabel htmlFor="NewsletterEmail">
          Email address
        </NewsletterLabel>

        <NewsletterInput
          type="email"
          required
          placeholder="johndoe@company.com"
          name="Email"
          id="NewsletterEmail"
        />
        <ButtonFormWhite text={"Subscribe"} textMargin={"4rem"} />
      </NewsletterForm>
    </NewsletterContainer>
  )
}

export default Newsletter
